// extracted by mini-css-extract-plugin
export var layoutContainer = "_41-0";
export var layoutContainerNoRounding = "_41-6";
export var layoutContainerOpen = "_41-5";
export var layoutContainerResizing = "_41-1";
export var mainContent = "_41-2";
export var resizeDivider = "_41-3";
export var slidePanel = "_41-4";